import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PayBills from "./PayBills";
import StreetParking from "./StreetParking";
import ProductsOverview from "./ProductsOverview";
import FeesTaxes from "./FeesTaxes";
import FinancialServices from "./FinancialServices";

const NAV_OFFSET = 72;

const scrollToSection = (hash: string) => {
  if (!hash) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  const el = document.querySelector(hash);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

export default function ProductsAndServices() {
  const location = useLocation();

  useEffect(() => {
    // Small delay lets the page paint before scrolling
    const timer = setTimeout(() => {
      scrollToSection(location.hash);
    }, 80);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <section id="pay-bills">
        <PayBills />
      </section>
      <section id="street-parking">
        <StreetParking />
      </section>
      <section id="goods-services">
        <ProductsOverview />
      </section>
      <section id="fees-taxes">
        <FeesTaxes />
      </section>
      <section id="financial-services">
        <FinancialServices />
      </section>
    </>
  );
}
